import PropTypes from 'prop-types';
import React from 'react';

class HotelContact extends React.Component {
  render() {
    const contact = this.props.contact;
    if (contact) {
      if (contact.first_name) {
        return (
          <p className="clearfix">
            {contact.first_name} {contact.last_name} ({contact.email})
          </p>
        );
      }
      return <p className="clearfix">{contact.email}</p>;
    }
    return <p>Hotel Contact missing.</p>;
  }
}
HotelContact.propTypes = {
  contact: PropTypes.object.isRequired,
};
export default HotelContact;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelContact.js